
const MicOff =({fill})=>{
    return(
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
	<path fill={fill} d="M15 10.6V5c0-1.66-1.34-3-3-3c-1.54 0-2.79 1.16-2.96 2.65zm3.08.4c-.41 0-.77.3-.83.71c-.05.32-.12.64-.22.93l1.27 1.27c.3-.6.52-1.25.63-1.94a.857.857 0 0 0-.85-.97M3.71 3.56a.996.996 0 0 0 0 1.41L9 10.27v.43c0 1.19.6 2.32 1.63 2.91c.75.43 1.41.44 2.02.31l1.66 1.66c-.71.33-1.5.52-2.31.52c-2.54 0-4.88-1.77-5.25-4.39a.84.84 0 0 0-.83-.71c-.52 0-.92.46-.85.97c.46 2.96 2.96 5.3 5.93 5.75V20c0 .55.45 1 1 1s1-.45 1-1v-2.28a7.1 7.1 0 0 0 2.55-.9l3.49 3.49a.996.996 0 1 0 1.41-1.41L5.12 3.56a.996.996 0 0 0-1.41 0" />
</svg>
)
}
export default MicOff;